import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { CohortBuilderPageTab } from '@verantos-dev/core-enums';

export const useActivePageTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activePageTab = searchParams.get('pageTab');

  // set default tab if no tab or invalid tab is provided
  useEffect(() => {
    const validTabs: CohortBuilderPageTab[] = Object.values(CohortBuilderPageTab);
    if (activePageTab === null || !validTabs.includes(activePageTab as CohortBuilderPageTab)) {
      setSearchParams((params) => {
        const newParams = new URLSearchParams(params);
        newParams.set('pageTab', CohortBuilderPageTab.events);
        return newParams;
      });
    }
  }, [activePageTab, setSearchParams]);

  return activePageTab as CohortBuilderPageTab;
};
